// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Dialog from "../Dialog/Dialog.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import DialogConfirmationModuleCss from "./DialogConfirmation.module.css";

let classes = DialogConfirmationModuleCss;

function DialogConfirmation(props) {
  let onDismiss = props.onDismiss;
  let onConfirm = props.onConfirm;
  return <Dialog.make
    className={props.className}
    visible={props.visible}
  >
    <header>
      <h3>
        {props.heading}
      </h3>
    </header>
    {props.children}
    <footer>
      <button
        className={Styles.button.variantPrimary}
        type={"submit"}
        onClick={param => onConfirm()}
      >
        {"Provést"}
      </button>
      <button
        className={Styles.button.base}
        type={"button"}
        onClick={param => onDismiss()}
      >
        {"Zrušit"}
      </button>
    </footer>
  </Dialog.make>;
}

let make = DialogConfirmation;

export {
  classes,
  make,
}
/* classes Not a pure module */
